module.exports = __webpack_public_path__ + "static/media/c42-groove.b1408212.png";